import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { ErrorBoundary } from "@/components/error-boundary";
import { BugReportWidget } from "@/components/bug-report";
import { QuickDealDesk } from "@/components/quick-deal-desk";

export const Route = createFileRoute("/practice")({
  head: () => ({
    meta: [
      { title: "The Training Room — Practice Mode | AROS FLOW" },
      {
        name: "description",
        content:
          "Run fictional seller calls end to end: random training properties, a guided walkthrough or free practice. Nothing here touches your live deals.",
      },
      { property: "og:title", content: "The Training Room — AROS FLOW Practice Mode" },
      {
        property: "og:description",
        content:
          "Practice live seller calls on fictional deals with guided coaching. Training data stays separate from your real pipeline.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: PracticePage,
});

function PracticePage() {
  return (
    <AppShell>
      <div className="mx-auto w-full max-w-6xl px-3 py-4 sm:px-4">
        <header className="mb-3">
          <Link
            to="/"
            className="focus-key text-[11px] uppercase tracking-[0.2em] text-muted-foreground hover:text-gold"
          >
            ← Back to AROS FLOW
          </Link>
          <h1 className="mt-1 text-xl font-semibold text-gold sm:text-2xl">The Training Room</h1>
          <p className="text-xs text-muted-foreground">
            Practice Mode — fictional deals only. Nothing saved here affects your live pipeline or
            synced deals.
          </p>
        </header>
        <ErrorBoundary label="Practice Mode">
          <QuickDealDesk practice />
        </ErrorBoundary>
      </div>
      <BugReportWidget />
    </AppShell>
  );
}
